import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["document_id"],
  _excluded2 = ["document_id"],
  _excluded3 = ["files"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { APIClient } from '../misc/APIClient';
import FormData from 'form-data';
import Axios from 'axios';
export var DocumentAPI = /*#__PURE__*/function (_APIClient) {
  function DocumentAPI() {
    _classCallCheck(this, DocumentAPI);
    return _callSuper(this, DocumentAPI, arguments);
  }
  _inherits(DocumentAPI, _APIClient);
  return _createClass(DocumentAPI, [{
    key: "find",
    value: function find(query) {
      return this.client.get("/v3/documents", {
        params: query
      }).then(this._data);
    }
  }, {
    key: "get",
    value: function get(id, params) {
      return this.client.get("/v3/documents/".concat(id), {
        params: params
      }).then(this._data);
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.client.post("/v3/documents", data).then(this._data);
    }
  }, {
    key: "update",
    value: function update(id, data) {
      return this.client.patch("/v3/documents/".concat(id), data, {
        params: {
          tags: true
        }
      }).then(this._data);
    }
  }, {
    key: "archive",
    value: function archive(id) {
      return this.client.patch("/v3/documents/".concat(id, "/archive"), {}, {
        params: {
          tags: true
        }
      }).then(this._data);
    }
  }, {
    key: "zipFiles",
    value: function zipFiles(payload) {
      return this.client.post("/v3/documents/zipFiles", payload).then(this._data);
    }
  }, {
    key: "assignType",
    value: function assignType(id, data) {
      return this.client.post("/v3/documents/".concat(id, "/assign-type"), data).then(this._data);
    }
  }]);
}(APIClient);
export var DocumentTagAPI = /*#__PURE__*/function (_APIClient2) {
  function DocumentTagAPI() {
    _classCallCheck(this, DocumentTagAPI);
    return _callSuper(this, DocumentTagAPI, arguments);
  }
  _inherits(DocumentTagAPI, _APIClient2);
  return _createClass(DocumentTagAPI, [{
    key: "find",
    value: function find(query) {
      return this.client.get("/v3/tags", {
        params: query
      }).then(this._data);
    }
  }, {
    key: "create",
    value: function create(data) {
      return this.client.post("/v3/tags", data).then(this._data);
    }
  }, {
    key: "update",
    value: function update(id, data) {
      return this.client.patch("/v3/tags/".concat(id), data).then(this._data);
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return this.client.delete("/v3/tags/".concat(id)).then(this._data);
    }
  }]);
}(APIClient);
export var DocumentAccessAPI = /*#__PURE__*/function (_APIClient3) {
  function DocumentAccessAPI() {
    _classCallCheck(this, DocumentAccessAPI);
    return _callSuper(this, DocumentAccessAPI, arguments);
  }
  _inherits(DocumentAccessAPI, _APIClient3);
  return _createClass(DocumentAccessAPI, [{
    key: "create",
    value: function create(data) {
      return this.client.post("/v3/accesses", data).then(this._data);
    }
  }, {
    key: "update",
    value: function update(id, data) {
      return this.client.patch("/v3/accesses/".concat(id), data).then(this._data);
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return this.client.delete("/v3/accesses/".concat(id)).then(this._data);
    }
  }]);
}(APIClient);
export var DocumentVersionAPI = /*#__PURE__*/function (_APIClient4) {
  function DocumentVersionAPI() {
    _classCallCheck(this, DocumentVersionAPI);
    return _callSuper(this, DocumentVersionAPI, arguments);
  }
  _inherits(DocumentVersionAPI, _APIClient4);
  return _createClass(DocumentVersionAPI, [{
    key: "find",
    value: function find(_ref) {
      var document_id = _ref.document_id,
        query = _objectWithoutProperties(_ref, _excluded);
      return this.client.get("/v3/documents/".concat(document_id, "/versions"), {
        params: query
      }).then(this._data);
    }
  }, {
    key: "create",
    value: function create(_ref2) {
      var document_id = _ref2.document_id,
        data = _objectWithoutProperties(_ref2, _excluded2);
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var headers = {};
      var reqOpts = {};
      var body = data;
      if (data.action.files) {
        headers['Content-Type'] = 'multipart/form-data';
        body = new FormData();
        var _data$action = data.action,
          files = _data$action.files,
          action = _objectWithoutProperties(_data$action, _excluded3);
        body.append('meta', JSON.stringify({
          action: action,
          message: data.message
        }));
        files.forEach(function (f, i) {
          return body.append("file".concat(i + 1), f, sanitizeFileName(f.name));
        });
        reqOpts.onUploadProgress = opts.onProgress;
      }
      return this.client.post("/v3/documents/".concat(document_id, "/versions"), body, reqOpts).then(this._data);
    }
  }, {
    key: "uploadFromURL",
    value: function uploadFromURL(documentUploadData, files) {
      return Promise.all(files.map(function (f, i) {
        return Axios.put(documentUploadData[i].url, f, {
          headers: {
            'Content-Type': files[i].type
          }
        });
      }));
    }
  }, {
    key: "getUploadUrl",
    value: function getUploadUrl(data) {
      return this.client.post("/v3/documents/".concat(data.document_id, "/versions/uploadUrl"), data).then(function (x) {
        return x.data;
      });
    }
  }, {
    key: "createFromUrl",
    value: function createFromUrl(data) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reqOpts = {};
      reqOpts.onUploadProgress = opts.onProgress;
      return this.client.post("/v3/documents/".concat(data.document_id, "/versions/fromUrl"), data, reqOpts).then(function (x) {
        return x.data;
      });
    }
  }]);
}(APIClient);

/**
 * Sanitizes a file name.
 * @param {string} str
 */
function sanitizeFileName(str) {
  return str.replace(/\//g, '_').replace(/\\/g, '_');
}
//# sourceMappingURL=API.js.map
